import axios from "axios";

export const THEME_REQUEST = "THEME_REQUEST";
export const THEME_SUCCESS = "THEME_SUCCESS";
export const THEME_FAIL = "THEME_FAIL";


export const fetchRestaurantTheme =
  (restaurantId) =>
  async (dispatch) => {

    try {

      dispatch({
        type: THEME_REQUEST,
      });

      const response = await axios.get(
        `/api/restaurants/${restaurantId}/config/`
      );

      dispatch({
        type: THEME_SUCCESS,
        payload: response.data,
      });

      return response.data;

    } catch (error) {

      const message =
        error.response?.data?.detail ||
        error.response?.data ||
        error.message ||
        "Failed to load restaurant theme";

      dispatch({
        type: THEME_FAIL,
        payload: message,
      });

      throw error;
    }
  };